/** Intervalo entre as tentativas de `Init` enquanto o SDK 3DS não aparece. */
export const INTERVALO_SDK_3DS_MS = 500

/**
 * Prazo para o SDK 3DS aparecer depois que a tela de pagamento carrega.
 * Passado esse tempo ele é tratado como ausente (bloqueado ou com falha de
 * rede), e a tela avisa antes de qualquer interação com o formulário.
 */
export const LIMITE_SDK_3DS_MS = 10_000

interface OpcoesEsperaSdk3DS {
  intervaloMs?: number
  limiteMs?: number
}

/**
 * Chama `tentar` (o `Init` do 3DS) na hora e, enquanto ela devolver `false`,
 * de novo a cada `intervaloMs`. Um SDK que só demora a carregar ainda é
 * inicializado; se `limiteMs` passar sem sucesso, `onAusente` é chamada uma
 * única vez. Devolve a função que cancela a espera (use no unmount).
 */
export default function esperarSdk3DS(
  tentar: () => boolean,
  onAusente: () => void,
  { intervaloMs = INTERVALO_SDK_3DS_MS, limiteMs = LIMITE_SDK_3DS_MS }: OpcoesEsperaSdk3DS = {}
): () => void {
  if (tentar()) return () => {}

  const inicio = Date.now()
  const timer = setInterval(() => {
    if (tentar()) {
      clearInterval(timer)
      return
    }

    if (Date.now() - inicio >= limiteMs) {
      clearInterval(timer)
      onAusente()
    }
  }, intervaloMs)

  return () => clearInterval(timer)
}
